@import 'styles/mixins';
@import 'styles/variables';

.thinLine {
  :global {
    .ant-skeleton-paragraph {
      padding-right: 26px;
      margin-bottom: 12px;

      & li {
        border-radius: 40px;
        margin-left: 16px;
        margin-top: 16px !important;
        padding-right: 10px;
        height: 20px !important;

        &:first-of-type {
          margin-top: 4px !important;
        }
      }
    }

    .ant-skeleton-content .ant-skeleton-paragraph > li {
      background: var(--dark-8) !important;
    }
  }
}
